'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIHelpIcon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _UIIcon = require('./UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _icons = require('icons/icons');

var icons = _interopRequireWildcard(_icons);

var _colors = require('HubStyleTokens/colors');

var _passthroughProps = require('../utils/propTypes/passthroughProps');

var _passthroughProps2 = _interopRequireDefault(_passthroughProps);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var USE_DARK = 'on-dark';
var USE_DEFAULT = 'default';

function UIHelpIcon(props) {
  var use = props.use,
      tooltipProps = props.tooltipProps,
      title = props.title,
      className = props.className,
      style = props.style,
      children = props.children,
      rest = _objectWithoutProperties(props, ['use', 'tooltipProps', 'title', 'className', 'style', 'children']);

  var iconColor = use === USE_DARK ? _colors.OLAF : _colors.EERIE;

  var classes = (0, _reactUtils.classNames)('private-help-icon', className, {
    'private-help-icon--inline': children
  });

  return _react2.default.createElement(
    'span',
    { className: classes, style: style },
    children,
    _react2.default.createElement(
      _UITooltip2.default,
      _extends({}, tooltipProps, { title: title }),
      _react2.default.createElement(
        'span',
        { tabIndex: 0 },
        _react2.default.createElement(_UIIcon2.default, _extends({
          className: 'private-help-icon__icon',
          name: icons.INFO,
          color: iconColor
        }, rest))
      )
    )
  );
}

var _UIIcon$propTypes = _UIIcon2.default.propTypes,
    size = _UIIcon$propTypes.size,
    color = _UIIcon$propTypes.color;


UIHelpIcon.defaultProps = {
  use: USE_DEFAULT
};

UIHelpIcon.propTypes = {
  size: size,
  color: color,
  className: _react.PropTypes.string,
  style: _react.PropTypes.object,
  use: _react.PropTypes.oneOf([USE_DARK, USE_DEFAULT]),
  tooltipProps: (0, _passthroughProps2.default)(_UITooltip2.default),
  title: _react.PropTypes.node.isRequired,
  children: _react.PropTypes.node
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/icon/UIHelpIcon.js
// module id = 337
// module chunks = 0